import { Flex } from '@servicetitan/anvil2';
import { ErrorBoundary } from '@servicetitan/financing-utils-shared';
import {
    FinancingInformationContainer,
    PlansContainer,
    AutoProviderLogo,
} from '@servicetitan/financing-plans-shared';
import { plansPanel, wrapper } from '../workflow/ApplicationWorkflow.module.scss';

interface SelectPlanStepProps {
    onPlanSelected?: () => void;
    canChangeProvider?: boolean;
}

export const SelectPlanStep = (props: SelectPlanStepProps) => {
    const { canChangeProvider = false, ...restProps } = props;

    return (
        <div className={plansPanel} style={{ width: '100%' }}>
            <div className={wrapper}>
                <Flex direction="column" gap="4">
                    <ErrorBoundary actionCausingError="loading available plans">
                        {canChangeProvider ? (
                            <FinancingInformationContainer showProviderSelection />
                        ) : (
                            <>
                                <AutoProviderLogo />
                                <FinancingInformationContainer />
                            </>
                        )}
                        <PlansContainer {...restProps} />
                    </ErrorBoundary>
                </Flex>
            </div>
        </div>
    );
};
